export const personal = [
  {
    nombre: "Élida Noelia Choque",
    descripcion: "Jefe de Unidad de Investigación",
    color: "#542141",
  },
  {
    nombre: "Mag. Julián Ortega Tolay",
    descripcion: "Referente del Comité de Ética",
    color: "#7e7e7eff",
  },
  {
    nombre: "Mónica Edith Sosa",
    descripcion: "Equipo técnico",
    color: "#7e7e7eff",
  },
];
